import { z } from 'zod/v3';
import { errorMap } from '../../../../common/utils';
import { AlgorithmSourceValidFormDataSchema } from './AlgorithmSourceValidFormDataSchema';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmSourcesValidFormDataSchema.translations.json';

const { addTranslations, t } = i18nNsFactory(
  'algorithm-sources-valid-form-data-schema',
);
addTranslations(translations);

const sourceErrorMap = errorMap(() => t('validation.sourceDimension.required'));

export const AlgorithmSourcesConfidentialityRuleSourceValidFormDataSchema =
  z.object(
    {
      dimension: z.string(sourceErrorMap).min(1),
      index: z.number(),
    },
    sourceErrorMap,
  );

const AlgorithmSourcesConfidentialityRuleValidFormDataSchema =
  z.discriminatedUnion('useDimension', [
    z.object({
      useDimension: z.literal(true),
      source: AlgorithmSourcesConfidentialityRuleSourceValidFormDataSchema,
    }),
    z.object({
      useDimension: z.literal(false),
      source:
        AlgorithmSourcesConfidentialityRuleSourceValidFormDataSchema.nullish(),
    }),
  ]);

export const AlgorithmSourcesValidFormDataSchema = z.object({
  sources: z.array(AlgorithmSourceValidFormDataSchema),
  confidentialityRule: AlgorithmSourcesConfidentialityRuleValidFormDataSchema,
});
